import orderInstance from '../instance'

const getCashRegisterCloseLast = () => {
	return orderInstance.get('/cashRegisterCloses/last')
}

export default getCashRegisterCloseLast
